import React from 'react';
import { injectIntl } from 'gatsby-plugin-intl'
import { useStaticQuery, graphql } from 'gatsby'
import styled from "styled-components";
import { device } from "../device";

import { DeviceItem } from './'

const DeviceListContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-left: -16px;
    margin-right: -16px;
`;
const DeviceListCell = styled.div`
    flex: 0 0 50%;
    max-width: 50%;
    padding: 0 16px;
    @media ${device.sm} {
        flex: 0 0 33.3333%;
        max-width: 33.3333%;
    }
    @media ${device.md} {
        flex: 0 0 25%;
        max-width: 25%;
    }
    @media ${device.xl} {
        flex: 0 0 20%;
        max-width: 20%;
    }
`;


const DevicesList = ({ intl }) => {
    

    const data = useStaticQuery(graphql`
        query DevicesList {
            allDevicesListJson {
                edges {
                    node {
                        name
                        imgSrc
                    }
                }
            }
        }
    `)
    return (
        <DeviceListContainer>
            {
                data.allDevicesListJson.edges.map((item) => {
                    return (
                        <DeviceListCell key={item.node.name}>
                            <DeviceItem 
                                name={item.node.name}
                                imgSrc={item.node.imgSrc}
                                />
                        </DeviceListCell>
                    );
                })
            }
        </DeviceListContainer>
    );
};

export default injectIntl(DevicesList);
